import { FilterOrder, FilterOrders } from "#/organisms";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { FindOrders } from "@/components/pages";
import { ORDER_STATE } from "@/types";
import { OrderFilterParams } from "@/api/order/interface";
import { useApi } from "@/api";
import { useFilter } from "@/hooks";

const FindOrdersView = () => {
  const { email } = useParams<'email'>();
  const { order, session } = useApi();
  const {
    filter,
    numberOfFilters,
    onOpenFilter,
    setShouldFilter,
    shouldFilter,
    showFilter,
    ...filterProps
  } = useFilter<FilterOrder>();
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [called, setCalled] = useState(false);
  const navigate = useNavigate();

  const isAdmin = useMemo(() => session.user?.admin || false, [session.user]);
  
  const getOrders = async (filterData?: OrderFilterParams) => {
    setLoadingOrders(true);
    await order.getOrderList(filterData);
    setLoadingOrders(false);
  }

  useEffect(() => {
    order.clearOrders();
  },[])

  useEffect(() => {
    if (email)
    {
      filterProps.onFilter({
        companyName: '',
        customerCode: '',
        customerEmail: email,
        dateFrom: '',
        dateOrderTaken: '',
        dateTo: '',
        dateWorkToBeDone: '',
        jobNumber: '',
        location: '',
        orderRef: '',
        state: '' as unknown as ORDER_STATE,
        workerId: '',
      })
    }
  }, [email]);

  useEffect(() => {
    if (shouldFilter) {
      if (filter) {
        getOrders(filter && {
          customerCode: filter.customerCode,
          customerEmail: filter.customerEmail,
          customerName: filter.companyName,
          dateFrom: filter.dateFrom,
          dateOrderTaken: filter.dateOrderTaken,
          dateTo: filter.dateTo,
          dateWorkToBeDone: filter.dateWorkToBeDone,
          orderId: filter.jobNumber,
          orderRef: filter.orderRef,
          orderState: filter.state || null,
          propertyAddress: filter.location,
        });
      } else {
        getOrders();
      }
      setShouldFilter(false);
    }
  }, [filter, shouldFilter]);

  const handleCreateNewOrder = useCallback(() => {
    navigate('/order-create');
  }, []);

  const handleSelectOrder = useCallback((orderId: string) => {
    navigate(`/order-view-backend/order=${orderId}`, {  });
  }, []);

  const handleFetchMore = async () => {
    console.log('');
  }

  return (
    <>
      <FindOrders
        isAdmin={isAdmin}
        loading={loadingOrders}
        numberOfFilters={numberOfFilters}
        orders={order.orders}
        onCreateNewOrder={handleCreateNewOrder}
        onFetchmore={handleFetchMore}
        onOpenFilter={onOpenFilter}
        onSelectOrder={handleSelectOrder}
      />
      {showFilter && <FilterOrders {...filterProps} filter={filter} numberOfFilters={numberOfFilters} showAdminFilter={isAdmin} />}
    </>
  );
}

export default FindOrdersView;